"use strict";
exports.__esModule = true;
exports.lightType = void 0;
var lightType;
(function (lightType) {
    lightType["Bench"] = "Bench";
    lightType["Linear"] = "Linear";
    lightType["LinearWithStove"] = "LinearWithStove";
    lightType["Roof"] = "Roof";
    lightType["RoofWithStove"] = "RoofWithStove";
    lightType["BenchWithStove"] = "BenchWithStove";
    lightType["NoLigthing"] = "NoLigthing";
    lightType["BenchWithRoof"] = "BenchWithRoof";
})(lightType = exports.lightType || (exports.lightType = {}));
;
